// components/Home.js
import React, {useState} from 'react';
import {Container, Typography, Button, Grid, Modal, Box, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function Home({setActiveComponent}) {
    const [open, setOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);

    const handleImageClick = (image) => {
        setCurrentImage(image);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentImage(null);
    };

    return (
        <Container id="home" className="home" style={{paddingTop: '2rem', paddingBottom: '2rem'}}>
            <Grid container spacing={4} alignItems="center">
                <Grid item xs={12} md={7}>
                    <Typography variant="h3" gutterBottom>Shri Anjaneya Temple</Typography>
                    <Typography variant="body1" paragraph>
                        <p className="shri-anjaneya-temple">
                            Nestled in the historic town of <strong>Ariyalur, Tamil Nadu, the Shri Anjaneya
                            Temple</strong> is a
                            century-old shrine dedicated to Lord Hanuman. <strong>Consecrated on August 1st, 1918, by
                            Shri
                            Periaswamy Iyer</strong> (affectionately remembered as Ariyalur Appa), the temple is home to
                            a
                            revered Swayambhu (self-manifested) form of Hanuman. Over the years, it has become a
                            spiritual landmark, drawing devotees from near and far to seek the blessings of the immortal
                            Lord.
                            <br/><br/>
                            The temple is especially known for its <strong>unique celebration of Hanuman Jayanthi during
                            the
                            Tamil month of Margazhi (Dhanur Maadham) on Moola Nakshathiram</strong>, a tradition that
                            has been
                            observed for <strong>94 consecutive years</strong>. Along with grand annual festivities and
                            rituals, the
                            temple stands as a living symbol of devotion, heritage, and the enduring bond between the
                            divine and the community of worshippers.
                            <br/><br/>
                            To learn more about the temple’s origins, traditions, and century-long journey, we invite
                            you to read more "About the Temple".
                        </p>
                    </Typography>
                    <Button
                        variant="contained"
                        style={{
                            marginTop: '1rem',
                            backgroundColor: '#ff511a',
                            color: '#ffffff',
                            fontFamily: 'Inter, Helvetica',
                            fontSize: '16px',
                            fontWeight: 700,
                            marginRight: '16px',
                            textTransform: 'none',
                            width: '180px',
                            height: '40px'
                        }}
                        onClick={() => setActiveComponent('About')}
                    >
                        About the Temple
                    </Button>
                </Grid>
                <Grid item xs={12} md={5}>
                    <img
                        src={require('../../assets/hanuman-home.jpeg')}
                        alt="Temple"
                        style={{width: '100%', height: 'auto', cursor: 'pointer'}}
                        onClick={() => handleImageClick(require('../../assets/hanuman-home.jpeg'))}
                    />
                </Grid>
            </Grid>
            <Modal open={open} onClose={handleClose}>
                <Box
                    sx={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        outline: 'none',
                        maxWidth: '90%',
                        maxHeight: '90%',
                    }}
                >
                    <IconButton
                        onClick={handleClose}
                        sx={{position: 'absolute', top: 0, right: 0}}
                    >
                        <CloseIcon/>
                    </IconButton>
                    <img src={currentImage} alt="Enlarged Temple" style={{width: '100%', height: 'auto'}}/>
                </Box>
            </Modal>
        </Container>
    );
}

export default Home;
